"use client";

import { useTranslation } from "@/lib/hooks/use-translation";

/**
 * The one line that says the mock screens are mocks.
 *
 * The product shots on this page are built as live UI rather than screenshots,
 * which means every figure in them is real text in the document — and a crawler
 * reading the page cannot tell a demo dashboard from a published result. That
 * is not hypothetical: this page shipped tier rows reading "999,999 คน" and
 * "฿999,999,999.00", numbers no human took for anything but placeholder because
 * the card crops them off, and which an answer engine had no reason to doubt.
 *
 * The figures are plausible demo values now, but the shots are still not claims
 * about Jelloducks, so they say so out loud. Two mechanisms, because neither is
 * enough alone:
 *
 *   this note      — visible to screen readers and to anything reading the
 *                    text, so the numbers are never encountered unlabelled.
 *                    `sr-only` rather than `hidden`: it must reach the
 *                    accessibility tree, and a sighted reader can already see
 *                    it is a picture of an app.
 *   data-nosnippet — Google's own opt-out, honoured for snippets and the AI
 *                    surfaces fed from them. It is on the mock roots, not here,
 *                    since it has to cover the figures rather than the label.
 *
 * Neither hides anything from indexing, and that is the point: the aim is that
 * whatever reads these numbers also reads what they are.
 */
export default function SampleDataNote() {
  const { t } = useTranslation();

  return <p className="sr-only">{t("mocks.sampleData")}</p>;
}
